<div class="container-visualizacao cliente-internet">
    <!-- Options -->
    <div class="row container-options">
        <div class="col-12">
            <span class="float-right">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" (click)="search()">
                        <i class="fas fa-search" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn btn-light" (click)="filterCollapse.clear()">
                        <i class="fas fa-eraser" aria-hidden="true"></i>
                    </button>
                    <button type="button" class="btn" [class.btn-light]="!filterCollapse?.isFilterDirty" [class.btn-danger]="filterCollapse?.isFilterDirty"
                        (click)="filterCollapse.toggleCollapse()">
                        <i class="fas fa-filter" aria-hidden="true"></i>
                        <i [class]="filterCollapse.collapseIcon" aria-hidden="true"></i>
                    </button>
                </div>                
            </span>
        </div>
    </div>
    
    <!-- Content -->
    <div class="row container-table" #containerTable>
        <div class="col-12">
            <div class="row container-filter">
                <div class="col-12">
                    <sgt-cliente-internet-filter-collapse
                        [filter]="filter"
                        (filterInitialized)="onFilterInitialized()"
                        #filterCollapse>
                    </sgt-cliente-internet-filter-collapse>
                </div>
            </div>
            
            <div class="row container-inner-table">
                <div class="col-12">
                    <table class="table table-striped table-hover table-bordered table-cliente-internet" id="tableClienteInternet">
                        <thead>
                            <tr>
                                <th class="col-options"></th>
                                <th class="col-nome">Cliente</th>
                                <th class="col-nome-representante">Representante</th>
                                <th class="col-ecommerce text-center">E-commerce</th>
                                <th class="col-mercado-livre text-center">Mercado Livre</th>
                                <th class="col-marketplace text-center">Marketplace</th>
                                <th class="col-urls">Links</th>
                            </tr>
                        </thead>
                        <tfoot>
                            <tr>
                                <td class="col-options"></td>
                                <td class="col-nome text-center">
                                    {{total?.quantidadeClientes | decimalFormat: 1:0:0}} cliente(s)
                                </td>
                                <td class="col-nome-representante"></td>
                                <td class="col-ecommerce text-center">
                                    {{total?.quantidadeEcommerce | decimalFormat: 1:0:0}} cliente(s)
                                </td>
                                <td class="col-mercado-livre text-center">
                                    {{total?.quantidadeMercadoLivre | decimalFormat: 1:0:0}} cliente(s)
                                </td>
                                <td class="col-marketplace text-center">
                                    {{total?.quantidadeMarketplace | decimalFormat: 1:0:0}} cliente(s)
                                </td>
                                <td class="col-urls"></td>                                                                                                
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal para atualizar os dados de internet -->
<sgt-cliente-internet-form-modal
    #formModal
    (afterUpdate)="onAfterUpdate()">
</sgt-cliente-internet-form-modal>